import React, { Component } from 'react';
import {Grid, CircularProgress, Typography} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
    grid: {
        width: '100%',
        height: '100vh'
    },
    typography: {
        marginTop: '1vw'
    }
});

class Loader extends Component {
    render() {
        const {classes} = this.props;
        return (
            <React.Fragment>
                <Grid
                    className={classes.grid}
                    container
                    direction="column"
                    justify="center"
                    alignItems="center"
                >
                    <CircularProgress size={50} />
                    <Typography className={classes.typography}>
                        Loading...
                    </Typography>
                </Grid>
            </React.Fragment>
        )
    }
}

const LoaderWithStyle = withStyles(styles)(Loader);
export {LoaderWithStyle as Loader};


// WEBPACK FOOTER //
// ./src/components/Templates/Loader.jsx